import { render, staticRenderFns } from "./ApiInboxWhatsappTemplate.vue?vue&type=template&id=43ce60ec&"
import script from "./ApiInboxWhatsappTemplate.vue?vue&type=script&lang=js&"
export * from "./ApiInboxWhatsappTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports